// extracted by mini-css-extract-plugin
export default {"tipContainer":"qUvgzw","tipDescription":"UNxPxn","link":"LUYDwp"};